import { render, staticRenderFns } from "./DbpyPD.vue?vue&type=template&id=f76080e4"
import script from "./DbpyPD.vue?vue&type=script&lang=js"
export * from "./DbpyPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports